<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
	[tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg" [token]="token">

	<ng-container *ngIf="consulta">

		<ul class="card-list-striped">
			<li><span class="text-secondary">Financiado em nome de
				</span><span>{{consulta?.gravameNomeFinanciado || "NÃO INFORMADO"}}</span></li>
			<li><span class="text-secondary">CPF/CNPJ do Financiado
				</span><span>{{consulta?.gravameDocFinanciado || "NÃO INFORMADO"}}</span></li>
			<li><span class="text-secondary">UF
				</span><span>{{consulta?.gravameUfGravame || "NÃO INFORMADO"}}</span></li>
			<li><span class="text-secondary">Nome Financiado
				</span><span>{{consulta?.gravameNomeFinanciado || "NÃO INFORMADO"}}</span></li>
			<li><span class="text-secondary">Descrição Status
				</span><span>{{consulta?.gravameDescricaoStatus || "NÃO INFORMADO"}}</span></li>
			<li><span class="text-secondary">Registro de inclusão
				</span><span>{{consulta?.gravameDataStatus || "NÃO INFORMADO"}}</span></li>
			<li><span class="text-secondary">Financiado por
				</span><span>{{consulta?.gravameNomeAgente || "NÃO INFORMADO"}}</span></li>
			<li><span class="text-secondary">Codigo Agente
				</span><span>{{consulta?.gravameCodigoAgente || "NÃO INFORMADO"}}</span></li>
			<li><span class="text-secondary">CNPJ Agente
				</span><span>{{consulta?.gravameCnpjAgente || "NÃO INFORMADO"}}</span></li>
			<li><span class="text-secondary">Placa </span><span>{{consulta?.gravamePlaca || "NÃO INFORMADO"}}</span>
			</li>
			<li><span class="text-secondary">Chassi </span><span>{{consulta?.chassi || "NÃO INFORMADO"}}</span></li>
			<li><span class="text-secondary">UF Placa </span><span>{{consulta?.gravamUfPlaca || "NÃO INFORMADO"}}</span>
			</li>
			<li><span class="text-secondary">Ano Modelo
				</span><span>{{consulta?.gravameAnoModelo || "NÃO INFORMADO"}}</span></li>
			<li><span class="text-secondary">Ano Fabricação
				</span><span>{{consulta?.gravameAnoFabricacao || "NÃO INFORMADO"}}</span></li>
			<li><span class="text-secondary">Numero Gravame
				</span><span>{{consulta?.gavameNumeroGravame || "NÃO INFORMADO"}}</span></li>
			<li><span class="text-secondary">Status Veiculo
				</span><span>{{consulta?.gravameStatusVeiculo || "NÃO INFORMADO"}}</span></li>
		</ul>

		<ng-container *ngIf="consulta?.gravameObs" class="card card-warning">
			<div class="card-msg d-flex flex-column flex-md-row">
				{{consulta?.gravameObs}}
			</div>
		</ng-container>

	</ng-container>

</app-card-consulta>
